import { CompanyResponse } from "./company.model";

export class User {
	email: string;
	firstName: string;
	id: number;
	lastName: string;
	parent: string;
}

export class UserResponse {
	adviser: boolean;
	alphanumericId: string;
	associate: boolean;
	balance: number;
	contadorGT: boolean;
	countryId: number;
	credit: boolean;
	currency: number;
	dateCreation: number;
	directAdviser: boolean;
	email: string;
	id: number;
	miContaGT: boolean;
	seller: boolean;
	validated: boolean;
}

export class UserSaved {
	admin: boolean;
	adviser: boolean;
	allRolesInCompanies: any;
	alphanumericId: string;
	associate: boolean;
	balance: number;
	canAdminCompanies: boolean;
	canAdminUsers: boolean;
	companiesReservedBalance: number;
	companyRoles: any;
	contadorGT: boolean;
	countryId: number;
	credit: boolean;
	currency: number;
	directAdviser: boolean;
	firstName: string;
	id: number;
	imageUrl: string;
	lastName: string;
	mail: string;
	passOk: boolean;
	seller: boolean;
	services: any;
	validated: boolean;
	userPartner: boolean;
}

export class PositionUserRequest {
	user: number;
	position: number;
	warehousesList = [];
	cashList = [];
}

export class PositionUserResponse {
	userId: number;
	positionRoleId: number;
	warehouse: number;
	cash?: number;
	company: number;
}

export class Warehouses {
	warehouse: number;
}

export class UserRequestRole {
	userName: string;
	email: string;

	constructor() {

	}
}

export class UserNitResponse {
	department: number;
	id: number;
	kindPerson: number;
	municipality: number;
	name: string;
	nit: string;
	taxRegime: number;
}

export class PaginationPartnerResponse {
	total: number;
	partners: PartnerResponse[];
}

export class PartnerResponse {
	id: number;
	email: string;
	name: string;
	showCompany: boolean;
	companies: CompanyResponse[] = [];
	loading: boolean;
}
